import { ModalComponentProps, ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useTypeIdNumber } from '../../../../../../../utils/hooks/useTypeIdNumber'
import { getActiveLangs, getAllClientManagerEmployees, getConfigParam, getDictionaryCountries, getSingleEmployeeParam, getUserInfo } from '../../../../../../../utils/reducers/getters'
import { useCallback, useEffect, useMemo, useState } from 'react'
import twinFetchPost, { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { addDictionaryExtraLine, dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { CustomerModelTypeAndAddress } from '../../../../../../../specificComponents/Customers/types'
import { CustomerGroupPayload, CustomerGroupsParsed } from '../../../../../../../utils/reducers/customers/customerGroups'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useCustomerTypesDict from '../../../../../../../utils/hooks/customer/useCustomerTypesDict'
import useCreateAllCustomerAddresOrWC from '../../../../../../../utils/hooks/customer/useCreateAllCustomerAddresOrWC'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import { EmployeesPayload } from '../../../../../../../utils/reducers/company/employees'
import { sortCountries } from '../../../../../../../utils/globals/sortCountries'
import ReactDOM from 'react-dom'
import { ModalOpenedSetTy, ModalOpenedTy } from '../../../../../../../baseComponents/Modal/types'
import { ModalFullCentered } from '../../../../../../../baseComponents/Modal'
import './modalCreateCustomer.sass'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import TwinIcon, { TwinIconProp } from '../../../../../../../baseComponents/TwinIcon'
import { faBuildings, faSuitcase, faUser, faXmark } from '@fortawesome/pro-light-svg-icons'
import { ButtonOrLoader } from '../../../../../../../baseComponents/Button'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import FormRenderer from '../../../../../../../forms/FormRenderer'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { EditCardTabsHorizontalWithoutLinks } from '../../../../../../../baseComponents/EditCardTabs'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import { changeErrorMessage } from '../../../../../../../utils/reducers/reduxDispatch'

type ModalCreateCustomerProps = ModalComponentProps & ReduxModalCreateCustomer & ModalCreateCustomerLogicProps & {}

const ModalCreateCustomer: React.FC<ModalCreateCustomerProps> = ({ customerGroups, employees, onSubmit, setOpened }) => {
    const { t } = useTwinTranslation()
    const { dictCustomerOrigins, handleShowCreateAddress, changeTypeCustomer, typeCustomerSelected, myEmployees, loading, myOnSubmit, setTabActive, tabActive, handleCustomerData, data } = useMocalCreateCustomerLogic({ employees, onSubmit, setOpened })
    const { specialCheckbox, specialName, specialFields } = useCreateAllCustomerAddresOrWC({typeCustomerSelected, createAddress: data?.createAddress, handleShowCreateAddress, data: data || {}})
    const { dictCustomerTypeFilter, customerGroupsTypesDict } = useCustomerTypesDict()
    const keyCustomerGroups = customerGroupsTypesDict[typeCustomerSelected || 0] as keyof CustomerGroupsParsed
    const nameField: FormElement<keyof CustomerModelTypeAndAddress>[] = []
    const tabs: ComponentTabObject = {
        'general': { component: CustomerGeneralDataTab, text: <CustomHeaderTextWithIconTab text={t('generalData', 'Datos generales')} icon={faSuitcase} /> },
        'contactInfo': { component: CustomerContactInfoTab, text: <CustomHeaderTextWithIconTab text={t('otherInfo', 'Otra información')} icon={faUser} /> }
    }
    
    if (parseInt(String(typeCustomerSelected)) !== -1) {
        nameField.unshift({
            name: 'name',
            label: t('name', 'Nombre'),
            component: 'InputWithLabelMargin',
            type: 'text',
            required: true
        })
        if (specialFields && specialFields.length) {
            tabs['address'] = { component: CustomerWorkingCenterTab, text: <CustomHeaderTextWithIconTab text={t('address', 'Dirección')} icon={faBuildings} /> }
        }
    }
    
    const fields: FormRender<CustomerModelTypeAndAddress> = [
        {
            cols: 3,
            className: 'first_header_create_customer_fields',
            elements: [
                ...nameField,
                ...specialName,
                {
                    name: 'customer_type',
                    label: t('customerType', 'Tipo de cliente'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictCustomerTypeFilter,
                    value: typeCustomerSelected || '0',
                    onChange: changeTypeCustomer,
                    required: true,
                    placeholder: t('selectCustomerType','Seleccionar tipo de cliente')
                },
                ...specialCheckbox
            ]
        },
    ]
    const parsedFields = useRenderParsedElements(fields, handleCustomerData, data || {})
    return (
        <ModalFullCentered className='modal_create_customer' opened={true} setOpened={() => setOpened(null)} onClickOut={false}>
            <CustomCreateCustomerHeader setOpened={setOpened} />
            <div className='flex flex-auto flex-col gap-y-15 overflow-auto p-30'>
                <div className='rounded-md bg-gray-FB p-25'>
                    <FormRenderer sections={parsedFields} />
                </div>
                <EditCardTabsHorizontalWithoutLinks tabs={tabs} tab={tabActive} onClick={setTabActive} className='modal_create_customer_tabs flex_tabs' extraComponentData={{ myEmployees, specialFields, customerGroups, keyCustomerGroups, dictCustomerOrigins, handleCustomerData, data }} />
            </div>
            <div className='h-100 flex items-center justify-between px-30 py-25 border-b border-gray-D6 bg-gray-FB create_customer_footer'>
                <div className='cursor-pointer ml-auto hover:text-green-21' onClick={() => setOpened(null)}><TwinTrans transKey='cancel'>Cancelar</TwinTrans></div>
                <ButtonOrLoader buttonIsDisabled={loading} className='ml-25 regular14' textButton={t('createCustomer', 'Crear cliente')} onClick={myOnSubmit} />
            </div>
        </ModalFullCentered>
    )
}
interface ModalCreateCustomerLogicProps {
    employees: EmployeesPayload
    onSubmit: OnSubmit
    setOpened: ModalOpenedSetTy
}
const useMocalCreateCustomerLogic = ({ employees, onSubmit, setOpened }: ModalCreateCustomerLogicProps) => {
    const { t } = useTwinTranslation()
    const { startLoading, endLoading, loading } = useIsLoading()
    const [tabActive, setTabActive] = useState('general')
    const [dictCustomerOrigins, setDictCustomerOrigins] = useState<TwinDictionary | null>(null)
    const [data, setData] = useState<TwinDictionary | null>(() => {
        const myEmployee = getUserInfo()
        let typeCustomerSelected = parseInt(String(getConfigParam('companyTypeOfCustomers')))
        if (typeCustomerSelected !== 0) {
             typeCustomerSelected = typeCustomerSelected - 1
        } else {
            typeCustomerSelected = getSingleEmployeeParam('table_allCustomers_selector') ?? 0
        }
        const initialData: TwinDictionary = {
            doVatVerification: true,
            ResponsibleEmployeeId: myEmployee?.Employee?.id,
            createAddress: false,
            customer_type: typeCustomerSelected,
            nameAddress: t('addressOne', 'Dirección 1')
        }
        return initialData
    })
    const messages = JSON.stringify({
        uncompletedAddress: t('uncompletedspecialFields', 'Datos de dirección incompletos'),
        uncompletedCustomerData: t('uncompletedCustomerFields', 'Datos del cliente incompletos')
    })

    const myEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getConfigParam('showOnlyClientManagerEmployees') === 'on' ? getAllClientManagerEmployees() || {} : employees || {}))), [employees])

    const handleCustomerData = useCallback((keyValue: string, value: any) => {
        setData((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld) {
                copyOld[keyValue] = value
                if (keyValue === 'customersForParse') {
                    copyOld['customersForParse'] = copyOld['customersForParse'].join(';')
                }
                return copyOld
            }
        })
    }, [setData])

    const changeTypeCustomer = useCallback((val: number) => {
        setData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            return { ...copy, customer_type: val }
        })
    }, [setData])

    const getDictCustomerOrigins = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerOrigin/getAllCustomerOrigins', {})
        if (result) {
            setDictCustomerOrigins(dictionaryComplexFromJsonArr(result))
        }
    }, [setDictCustomerOrigins])

    const handleShowCreateAddress = useCallback((val: boolean) => {
        setData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            return {...copy, createAddress: val}
        })
    }, [setData])

    const beforeSubmit = useCallback((paramData: TwinDictionary) => {
        const messagesParsed = JSON.parse(messages)
        let myData = JSON.parse(JSON.stringify(paramData || {}))
        if(myData.name){
            myData['customerContactName'] = myData['customerContactName'] ?? myData.name
            myData['name_to'] = myData['name_to'] ?? myData.name
        }
        if (!myData?.name || myData?.customer_type === '-1') {
            changeErrorMessage(messagesParsed?.uncompletedCustomermyData)
            endLoading()
            return false
        } else if (myData?.createAddress) {
            if (!myData?.nameAddress || !myData?.name_to || !myData?.postal_code || !myData?.address || !myData?.city || !myData?.country || !myData?.state) {
                changeErrorMessage(messagesParsed?.uncompletedAddress)
                setTabActive('address')
                endLoading()
                return false
            }
        }
        return myData
    }, [endLoading, messages])

    const myOnSubmit = useCallback(async (values: any) => {
        startLoading()
        const resultBeforeSubmit = beforeSubmit(data || {})
        if (resultBeforeSubmit) {
            const result = await twinFetchPost('/api/app/customer/createCustomer', {...resultBeforeSubmit})
            if (result) {
                onSubmit(result, values)
                endLoading()
                if(result.status === 200){
                    setOpened(null)
                } else if(result.status === 422){
                    changeErrorMessage(true)
                }
            }
        }
    }, [onSubmit, endLoading, setOpened, data, startLoading, beforeSubmit])

    useEffect(() => {
        getDictCustomerOrigins()
    }, [getDictCustomerOrigins])

    return { dictCustomerOrigins, handleShowCreateAddress, changeTypeCustomer, typeCustomerSelected: data?.customer_type, myEmployees, loading, myOnSubmit, tabActive, setTabActive, handleCustomerData, data, setData }
}

interface CustomCreateCustomerHeaderProps {
    setOpened: (value: React.SetStateAction<ModalOpenedTy>) => void
}

const CustomCreateCustomerHeader: React.FC<CustomCreateCustomerHeaderProps> = ({ setOpened }) => {
    return (
        <div className='h-75 flex items-center justify-between py-25 px-30 border-b border-gray-D6 bg-gray-FB create_customer_header'>
            <div className='flex gap-x-15 items-center'>
                <TwinIcon icon={faBuildings} className='w-22 h-22 text-green-43' />
                <div className='regular22'><TwinTrans transKey='createCustomer'>Crear cliente</TwinTrans></div>
            </div>
            <div onClick={() => setOpened(null)} className='cursor-pointer hover:text-green-21 flex gap-x-10 items-center'>
                <TwinIcon icon={faXmark} className='mb-1' fontSize={25} />
            </div>
        </div>
    )
}

interface CustomHeaderTextWithIconTabProps {
    icon: TwinIconProp
    text: string
}

const CustomHeaderTextWithIconTab: React.FC<CustomHeaderTextWithIconTabProps> = ({ icon, text }) => {
    return (
        <div className='flex customer_header_text_tab items-center' >
            <TwinIcon className='mr-10 text-16' icon={icon}/>
            <span>{text}</span>
        </div>
    )
}

interface CustomerGeneralDataTabProps {
    myEmployees: TwinDictionary
    handleCustomerData: (name: string, value: any) => void
    data: TwinDictionary
}

const CustomerGeneralDataTab: React.FC<CustomerGeneralDataTabProps> = ({ myEmployees, data, handleCustomerData }) => {
    const { t } = useTwinTranslation()
    const myEmployee = getUserInfo()
    const fields: FormRender<CustomerModelTypeAndAddress> = [
        {
            cols: 3,
            elements: [
                {
                    name: 'customerContactName',
                    label: t('customerContactName', 'Nombre persona de contacto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    value: data?.customerContactName ?? data?.name
                },
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email'
                },
                {//@ts-ignore
                    name: '',
                    component: 'Custom',
                    render: () => <CustomCustomerIdDocumentSelect data={data} handleCustomerData={handleCustomerData} />
                },
                {
                    name: 'nationality',
                    label: t('nationality', 'Nacionalidad'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    placeholder: t('selectCountry', 'Selecciona el país')
                },
                {
                    name: 'code',
                    label: t('customerCode', 'Código de Cliente'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
                {
                    name: 'ResponsibleEmployeeId',
                    label: t('ourManager', 'Nuestro gestor'),
                    component: 'CustomSelectWithSearchBar',
                    items: myEmployees || {},
                    value: myEmployee?.Employee?.id,
                    fieldName: 'fullname_short',
                    sortItems: true,
                    placeholder: t('selectOurManager','Selecciona tu gestor')
                },
            ]
        },
    ]
    const parsedFields = useRenderParsedElements(fields, handleCustomerData, data || {})
    return (
        <FormRenderer className='py-25' sections={parsedFields} />
    )
}

interface CustomCustomerIdDocumentSelectProps {
    handleCustomerData: (name: string, value: any) => void
    data: TwinDictionary
}

const CustomCustomerIdDocumentSelect: React.FC<CustomCustomerIdDocumentSelectProps> = ({ data, handleCustomerData }) => {
    const { typesIdNumber } = useTypeIdNumber()
    const { t } = useTwinTranslation()
    const fields: FormRender<CustomerModelTypeAndAddress> = [
        {
            cols: 3,
            className: 'id_document_inner',
            elements: [
                {
                    name: 'type_id_number',
                    label: t('idDocumentation', 'Documento'),
                    component: 'CustomSelect',
                    items: typesIdNumber,
                    value: 0,
                },
                {
                    name: 'id_number',
                    label: t('id_number', 'DNI'),
                    component: 'InputWithLabelMargin',
                    className: 'customer_id_number',
                    type: 'text',
                    placeholder: t('writeHere', 'Escribe aquí')
                },
                {
                    name: 'doVatVerification',
                    component: 'CheckboxMargin',
                    className: 'check_id_number_checkbox',
                    label: t('check', 'Verificar'),
                    defaultChecked: true
                },
            ]
        },
    ]
    const parsedFields = useRenderParsedElements(fields, handleCustomerData, data || {})
    return (
        <FormRenderer className='custom_customer_id_document' sections={parsedFields} />
    )
}

interface CustomerContactInfoTabProps {
    dictCustomerOrigins: TwinDictionary | null
    handleCustomerData: (name: string, value: any) => void
    data: TwinDictionary
    customerGroups: CustomerGroupPayload
    keyCustomerGroups: keyof CustomerGroupsParsed
}

const CustomerContactInfoTab: React.FC<CustomerContactInfoTabProps> = ({ dictCustomerOrigins, data, handleCustomerData, customerGroups, keyCustomerGroups }) => {
    const { t } = useTwinTranslation()
    const groupFields: FormElement<keyof CustomerModelTypeAndAddress>[] = []
    if (customerGroups?.[keyCustomerGroups] && customerGroups?.[keyCustomerGroups].length) {
        groupFields.push({
            name: 'customersForParse',
            label: t('customerGroups', 'Grupo de clientes'),
            selectedValues: [],
            component: 'CustomSSearchBarWithHeaderChildrenTags',
            placeholder: t('selectYourGroup', 'Selecciona el grupo'),
            items: dictionaryComplexFromJsonArr(customerGroups?.[keyCustomerGroups] || []),
            displayTagsLength: 2,
        })
    }
    const fields: FormRender<CustomerModelTypeAndAddress> = [
        {
            cols: 3,
            elements: [
                {
                    name: 'web',
                    label: t('web', 'Página web'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                },
                {
                    name: 'CustomerOriginId',
                    label: t('origin', 'Origen'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictCustomerOrigins || {},
                },
                ...groupFields,
                {
                    name: 'notes',
                    label: t('notes', 'Notas'),
                    component: 'TextArea',
                    placeholder: t('writeDownYourNotes', 'Escribe tus observaciones'),
                    parentClassName: returnClassOfSpanTemplate(3),
                },
            ]
        },
    ]
    const parsedFields = useRenderParsedElements(fields, handleCustomerData, data || {})
    return (
        <FormRenderer className='py-25' sections={parsedFields} />
    )
}

interface CustomerWorkingCenterTabProps {
    specialFields: FormRender<any>
    handleCustomerData: (name: string, value: any) => void
    data: TwinDictionary
}

const CustomerWorkingCenterTab: React.FC<CustomerWorkingCenterTabProps> = ({ specialFields, data, handleCustomerData }) => {
    const parsedFields = useRenderParsedElements(specialFields, handleCustomerData, data || {})
    return (
        <FormRenderer className='py-25' sections={parsedFields} />
    )
}

const useRenderParsedElements = (form: FormRender, handleChange: (name: string, value: any) => void, data?: TwinDictionary) => {
    const parsedFields = useMemo(() => {
        let result: FormRender = []
        for (const sectionKey in form) {
            const section = form[sectionKey]
            result.push({
                ...section,
                elements: []
            })
            for (const itemKey in section.elements) {
                const item = { ...form[sectionKey].elements[itemKey] } as any
                const { name, onChange } = item
                const value = data?.[String(name)]
                result[sectionKey].elements.push({
                    ...item,
                    onChange: async (value: any) => { await handleChange(String(name), value); await onChange?.(value) },
                    value: value ?? item.value ?? item.defaultValue
                })

            }
        }
        return [...result]
    }, [form, handleChange, data])

    return parsedFields
}

interface ModalCreateCustomerProjectOutsideProps extends ModalCreateCustomerOutsiderLogicProps { }

export const ModalCreateCustomerOutside: React.FC<ModalCreateCustomerProjectOutsideProps> = ({ ...rest }) => {
    const { mySetOpened } = useModalCreateCustomerOutsiderLogic({ ...rest })
    return (
        ReactDOM.createPortal(
            <ModalCreateCustomer {...rest as any} setOpened={mySetOpened} stopPropagation={true} />,
            document.body
        )
    )
}

interface ModalCreateCustomerOutsiderLogicProps extends ModalEditComponentProps {
    setLockOnClickOut?: (lock: boolean) => void
}
const useModalCreateCustomerOutsiderLogic = ({ setOpened, setLockOnClickOut }: ModalCreateCustomerOutsiderLogicProps) => {
    const mySetOpened: ModalOpenedSetTy = useCallback((value) => {
        if (value === null) {
            setLockOnClickOut?.(false)
        }
        setOpened(value)
    }, [setLockOnClickOut, setOpened])

    useEffect(() => {
        setLockOnClickOut?.(true)
    }, [setLockOnClickOut])
    return { mySetOpened }
}

const modalCreateCustomerDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setCustomerGroups: (payload: CustomerGroupPayload) => ({ type: 'CHANGE_CUSTOMER_GROUP', payload }),
}

export type ReduxModalCreateCustomer = ConnectedProps<typeof ModalCreateCustomerConnect>
const mapModalCreateCustomerConnector = (state: AllReduxPayloads) => ({ customerGroups: state.customerGroups, employees: state.employees })
const ModalCreateCustomerConnect = connect(mapModalCreateCustomerConnector, modalCreateCustomerDispatch)

const modalCreateCustomerConnectLoading = withLoading(ModalCreateCustomer, [{ fetchUrl: '/api/app/customer/customerGroup/getAllCustomersGroup', propName: 'customerGroups', setFunctionName: 'setCustomerGroups' }, { fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])

export default ModalCreateCustomerConnect(modalCreateCustomerConnectLoading);